import classNames from 'classnames/bind';

import { Telelecope } from '../../assets/icons/Icons';
import Button from '../Button/Button';
import styles from './notFound.module.scss';

const cx = classNames.bind(styles);

interface Props {
  /** Adds padding when nav bar is present */
  hasNav?: boolean;
  /** Path to navigate to */
  href?: string;
  /** Overrides default title of the 404 page */
  title?: string;
  /** Overrides default detail text of the 404 page */
  details?: string;
  hideButton?: boolean;
}

const defaultProps: { [key: string]: string } = {
  href: '/',
  title: 'We couldn’t find this page',
  details:
    'We can’t seem to find the page you’re looking for. Try going back to the previous page or return to the dashboard.',
};

const NotFound = ({
  hasNav = false,
  href = defaultProps.href,
  title = defaultProps.title,
  details = defaultProps.details,
  hideButton = false,
}: Props) => {
  return (
    <div className={cx('not-found', 'page-bg', { 'has-nav': hasNav })} data-testid='not-found'>
      {Telelecope}
      <h1 className={cx('not-found__title')}>{title}</h1>
      <p className={cx('not-found__details')}>{details}</p>
      {!hideButton && (
        <Button className={cx('not-found__button')} href={href} type='link-primary' size='large'>
          Return to Dashboard
        </Button>
      )}
    </div>
  );
};

export default NotFound;
